export function useProgressBar(_a) {
    var progress = _a.progress, max = _a.max, labelPrimary = _a.labelPrimary, labelSecondary = _a.labelSecondary;
    var progressPercent = Math.min(progress / max, 1) * 100;
    var renderLabels = !!labelPrimary || !!labelSecondary;
    return {
        progressPercent: progressPercent,
        renderLabels: renderLabels
    };
}
